import { GrafanaProvisionedAlertRule } from '@logz-pkg/models';
import { CrudApiService } from '../utilities/crud.api.service';
import { ICrudApiService } from '../utilities/types';

const base = '/grafana-app/unified/api/v1/provisioning/alert-rules';
export class GrafanaAlertApiService implements ICrudApiService<GrafanaProvisionedAlertRule> {
  crudApiService = new CrudApiService({ modelDefinition: GrafanaProvisionedAlertRule });

  urls = {
    base,
    rule: (uid: string) => `${base}/${uid}`,
  };

  getAll = async (): Promise<GrafanaProvisionedAlertRule[]> => {
    return this.crudApiService.getAll(this.urls.base);
  };

  getOne = async (uid: string): Promise<GrafanaProvisionedAlertRule> => {
    return this.crudApiService.get(this.urls.rule(uid));
  };

  create = async (rule: GrafanaProvisionedAlertRule): Promise<GrafanaProvisionedAlertRule> => {
    return this.crudApiService.create(this.urls.base, rule);
  };

  update = async (rule: GrafanaProvisionedAlertRule): Promise<GrafanaProvisionedAlertRule> => {
    if (!rule.uid) {
      throw new Error('Cannot update alert rule without uid');
    }

    return this.crudApiService.update(this.urls.rule(rule.uid), rule);
  };

  deleteRule = async (uid: string): Promise<void> => {
    await this.crudApiService.delete(this.urls.rule(uid));
  };
}

export const grafanaAlertApiService = new GrafanaAlertApiService();
